import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { GraduationCap, ArrowRight } from 'lucide-react';
import { cpdAPI } from '../../lib/cpdRegisterAPI';
import { CPDStatusBadge } from './CPDStatus';

const Stat = ({ label, value, children, testId }) => (
  <div className="rounded-lg border p-3"><div className="text-xs text-muted-foreground flex items-center gap-1">{children || label}</div>
    <p className="text-2xl font-bold" data-testid={testId}>{value}</p></div>
);

// Shown to admin/manager/auditor only (API returns 403 to others → hidden).
export const CPDComplianceCard = () => {
  const [s, setS] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { cpdAPI.complianceSummary().then(setS).catch(() => setS(null)); }, []);
  if (!s) return null;
  return (
    <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/compliance/cpd?tab=team')} data-testid="cpd-compliance-card">
      <CardHeader className="flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-base flex items-center gap-2"><GraduationCap className="w-4 h-4" /> CPD Compliance</CardTitle>
        <span className="text-xs text-[#0055FF] flex items-center gap-1">Team CPD <ArrowRight className="w-3 h-3" /></span>
      </CardHeader>
      <CardContent className="grid grid-cols-2 md:grid-cols-6 gap-3">
        <Stat value={s.staff_compliant} testId="cpd-card-compliant"><CPDStatusBadge status="COMPLIANT" /></Stat>
        <Stat value={s.attention_required} testId="cpd-card-attention"><CPDStatusBadge status="ATTENTION_REQUIRED" /></Stat>
        <Stat value={s.high_risk} testId="cpd-card-high-risk"><CPDStatusBadge status="HIGH_RISK" /></Stat>
        <Stat value={s.non_compliant} testId="cpd-card-non-compliant"><CPDStatusBadge status="NON_COMPLIANT" /></Stat>
        <Stat label="Missing evidence" value={s.missing_evidence} testId="cpd-card-missing-evidence" />
        <Stat label="Periods ending ≤ 90 days" value={s.expiring_within_90_days} testId="cpd-card-expiring" />
      </CardContent>
    </Card>
  );
};
